/* Musettino — tier buy box, size finder, sticky bar, delivery dates. */
(() => {
  const DAY = 864e5;
  const fmt = (d) => d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'long' });
  const addDays = (from, n, business) => {
    const d = new Date(from);
    if (!business) return new Date(d.getTime() + n * DAY);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
    return d;
  };

  // <mz-delivery data-min="5" data-max="10" data-business="false">: fills "tra il X e il Y".
  customElements.get('mz-delivery') || customElements.define('mz-delivery', class extends HTMLElement {
    connectedCallback() {
      const now = new Date(), biz = this.dataset.business === 'true';
      const a = addDays(now, +this.dataset.min, biz), b = addDays(now, +this.dataset.max, biz);
      this.innerHTML = `tra <b>${fmt(a)}</b> e <b>${fmt(b)}</b>`;
    }
  });

  // <mz-cutoff data-date="2026-12-08" data-from="2026-11-15">static text</mz-cutoff>: real day countdown, Rome time.
  // Test another day with ?mz_today=2026-11-20.
  customElements.get('mz-cutoff') || customElements.define('mz-cutoff', class extends HTMLElement {
    connectedCallback() {
      const iso = /^\d{4}-\d{2}-\d{2}$/, { date, from } = this.dataset;
      if (!iso.test(date || '')) return;
      const q = new URLSearchParams(location.search).get('mz_today');
      const today = iso.test(q || '') ? q : new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome' }).format(new Date());
      if (iso.test(from || '') && today < from) return;
      const utc = (s) => Date.UTC(+s.slice(0, 4), +s.slice(5, 7) - 1, +s.slice(8, 10));
      const days = Math.round((utc(date) - utc(today)) / DAY);
      const label = new Date(utc(date)).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', timeZone: 'UTC' });
      this.innerHTML = days > 1 ? `Mancano <b>${days} giorni</b> all'ultimo ordine per Natale (${label}).`
        : days === 1 ? `<b>Domani</b> è l'ultimo giorno per averla a Natale (${label}).`
        : days === 0 ? `<b>Oggi</b> è l'ultimo giorno per averla a Natale.`
        : `Dopo ${/^(8|11) /.test(label) ? "l'" : 'il '}${label} la consegna per Natale non è garantita.`;
    }
  });

  // Opens the size finder from anywhere (steps section, CTA buttons).
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-mz-finder]');
    if (f) { e.preventDefault(); document.dispatchEvent(new CustomEvent('mz:finder', { detail: f.dataset.mzFinder || 'renna1' })); }
    const s = e.target.closest('[data-mz-scroll-buy]');
    if (s && document.getElementById('mz-buy')) { e.preventDefault(); document.getElementById('mz-buy').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  customElements.get('mz-gallery') || customElements.define('mz-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mz-gallery__track');
      this.count = this.track.children.length;
      this.nav = [...this.querySelectorAll('[data-slide]')];
      this.thumbRow = this.querySelector('.mz-gallery__thumbs');
      this.prev = this.querySelector('[data-mz-prev]');
      this.next = this.querySelector('[data-mz-next]');
      this.nav.forEach((t) => t.addEventListener('click', () => this.go(+t.dataset.slide)));
      this.prev?.addEventListener('click', () => this.go(this.current - 1));
      this.next?.addEventListener('click', () => this.go(this.current + 1));
      this.current = 0;
      let raf = 0;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync(Math.round(this.track.scrollLeft / this.track.clientWidth)));
      }, { passive: true });
    }
    sync(i) {
      if (i === this.current && this.synced) return;
      this.current = i; this.synced = true;
      this.nav.forEach((t) => t.setAttribute('aria-current', +t.dataset.slide === i));
      this.prev?.toggleAttribute('data-off', i <= 0);
      this.next?.toggleAttribute('data-off', i >= this.count - 1);
      const th = this.thumbRow?.querySelector(`[data-slide="${i}"]`);
      if (th && this.thumbRow.scrollWidth > this.thumbRow.clientWidth) {
        this.thumbRow.scrollTo({ left: th.offsetLeft - (this.thumbRow.clientWidth - th.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    go(i) {
      i = Math.max(0, Math.min(this.count - 1, i));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }
    goMedia(id) { const s = this.querySelector(`[data-media-id="${id}"]`); if (s) this.go(+s.dataset.index); }
  });

  customElements.get('mz-buy') || customElements.define('mz-buy', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-mz-json]').textContent);
      this.btn = this.querySelector('[data-mz-add]');
      this.err = this.querySelector('[data-mz-err]');
      this.dialog = this.querySelector('dialog');
      this.addon = this.querySelector('[data-mz-addon-input]');
      this.addonKinds = (this.dataset.addonKinds || '').split(/\s+/);
      this.querySelectorAll('input[name="mz-tier"]').forEach((r) => r.addEventListener('change', () => this.render()));
      if (this.addon) this.addon.addEventListener('change', () => this.render());
      this.picks = this.querySelector('[data-mz-picks]');
      this.querySelectorAll('.mz-item select').forEach((r) => r.addEventListener('change', (e) => this.onOption(e)));
      this.btn.addEventListener('click', () => this.add());
      document.addEventListener('mz:finder', (e) => this.openFinder(e.detail));
      this.dialog.querySelector('[data-mz-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.querySelectorAll('input[type="number"]').forEach((i) => i.addEventListener('input', () => this.calc()));
      this.dialog.querySelector('[data-mz-apply]').addEventListener('click', () => this.apply());
      // "How to measure": closes the finder and plays the measuring video from the start.
      const howto = this.dialog.querySelector('[data-mz-howto]'), clip = document.getElementById('mz-misura');
      if (howto && clip) {
        howto.hidden = false;
        howto.addEventListener('click', (e) => {
          e.preventDefault();
          this.dialog.close();
          clip.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const v = clip.querySelector('video');
          if (v) { v.currentTime = 0; v.play().catch(() => {}); }
        });
      }
      this.sticky();
      this.render();
    }
    tier() { return this.querySelector('input[name="mz-tier"]:checked'); }
    items() { return [...this.querySelectorAll('.mz-item:not([hidden])')]; }
    money(cents) {
      const fmt = this.data.money || '€{{amount_with_comma_separator}}';
      const [i, d] = (cents / 100).toFixed(2).split('.');
      const comma = `${i.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${d}`;
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k.includes('comma') ? comma : `${i.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${d}`));
    }
    render() {
      // No tiers (gilet, bavaglino pages): one item at the product price.
      const t = this.tier(), qty = t ? +t.dataset.qty : 1;
      // The pickers live inside the chosen tier box, so only one set is ever open.
      const box = t && t.closest('.mz-tier');
      if (box && this.picks.parentElement !== box) box.append(this.picks);
      this.picks.dataset.qty = qty;
      const addonOk = !!t && !!this.addon && this.addonKinds.includes(t.dataset.kind);
      const wrap = this.querySelector('[data-mz-addon]');
      if (wrap) wrap.hidden = !addonOk;
      if (this.addon && !addonOk) this.addon.checked = false;
      const withSweater = addonOk && this.addon.checked;
      // One tutina: the gilet line says what it unlocks (free shipping + gift); otherwise the usual line.
      const single = !!t && t.dataset.kind === 'single';
      const lineSingle = this.querySelector('[data-mz-addon-single]'), lineMulti = this.querySelector('[data-mz-addon-multi]');
      if (lineSingle) { lineSingle.hidden = !single; if (lineMulti) lineMulti.hidden = single; }
      this.querySelectorAll('.mz-item').forEach((el) => {
        const it = el.dataset.item;
        el.hidden = it === 'sweater' ? !withSweater : +(it.slice(-1)) > qty;
      });
      // 2+ garments: gift and free shipping (the shipping rate is free from €45, i.e. 2 garments).
      const gift = qty >= 2 || withSweater, card = this.querySelector('[data-mz-gift]');
      this.querySelectorAll('[data-mz-ship-yes]').forEach((e) => { e.hidden = !gift; });
      this.querySelectorAll('[data-mz-ship-no]').forEach((e) => { e.hidden = gift; });
      if (card) {
        card.querySelector('[data-mz-gift-yes]').hidden = !gift;
        card.querySelector('[data-mz-gift-no]').hidden = gift;
        card.classList.toggle('is-off', !gift);
      }
      this.btn.querySelector('[data-mz-price]').textContent = this.money(+(t || this).dataset.cents + (withSweater ? +this.addon.dataset.cents : 0));
      this.err.textContent = '';
    }
    onOption(e) {
      const item = e.target.closest('.mz-item'), sel = e.target;
      sel.classList.remove('is-err');
      const sw = sel.parentElement.querySelector('[data-mz-swatch]');
      if (sw) sw.style.background = sel.selectedOptions[0].dataset.swatch;
      this.decorate(item);
      const v = this.variant(item);
      if (v && v.media && item.dataset.item === 'renna1') this.closest('.mz-product').querySelector('mz-gallery')?.goMedia(v.media);
      this.err.textContent = '';
    }
    // The thumbnail follows the colour; once a size is set, a line says what it fits.
    decorate(item) {
      const color = item.querySelector('select[data-opt="1"]')?.value;
      const size = item.querySelector('select[data-opt="2"]');
      const shot = (this.data[item.dataset.product] || []).find((v) => v.o1 === color && v.img);
      const img = item.querySelector('.mz-item__thumb img');
      if (img && shot && !img.src.startsWith(shot.img.split('?')[0])) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = shot.img; }
      const fit = item.querySelector('[data-mz-fit]');
      if (!size || !fit) return;
      size.classList.toggle('is-set', !!size.value);
      fit.hidden = !size.value;
      if (!size.value) return;
      const row = (this.data.sizes[item.dataset.product] || []).find((x) => x.label === size.value);
      fit.innerHTML = `<span><b>Taglia ${size.value}</b>${row && row.cmax ? ` · torace fino a ${row.cmax} cm, schiena fino a ${row.bmax} cm` : ''}</span>`;
    }
    variant(item) {
      if (!item.querySelector('select')) return this.data[item.dataset.product][0];
      const o1 = item.querySelector('select[data-opt="1"]')?.value;
      const o2 = item.querySelector('select[data-opt="2"]')?.value;
      return this.data[item.dataset.product].find((v) => v.o1 === o1 && v.o2 === o2);
    }
    add() {
      const lines = [];
      for (const item of this.items()) {
        const v = this.variant(item);
        if (!v) {
          this.err.textContent = `Scegli la taglia: ${item.dataset.label.toLowerCase()}.`;
          item.querySelectorAll('select').forEach((s) => { if (!s.value) s.classList.add('is-err'); });
          item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        lines.push({ id: v.id, quantity: 1 });
      }
      this.btn.setAttribute('aria-busy', 'true');
      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      }).then((r) => r.json()).then((res) => {
        if (res.status) { this.err.textContent = res.description || 'Qualcosa non ha funzionato. Riprova.'; return; }
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) { location.href = `${window.Shopify?.routes?.root || '/'}cart`; return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mz-buy' });
      }).catch(() => { this.err.textContent = 'Connessione assente. Riprova.'; })
        .finally(() => this.btn.removeAttribute('aria-busy'));
    }
    // --- size finder ---
    openFinder(target) {
      // "auto": the first visible renna still without a size.
      if (target === 'auto') {
        const open = this.items().find((i) => i.dataset.product === 'renna' && !i.querySelector('select[data-opt="2"]').value);
        target = open ? open.dataset.item : 'renna1';
      }
      this.target = target;
      this.dialog.showModal();
      this.calc();
    }
    fit(chart, chest, back) {
      chart = (chart || []).filter((s) => s.cmax > 0 && s.bmax > 0);
      if (!chart.length) return null;
      return chart.find((s) => chest <= s.cmax && back <= s.bmax) || false;
    }
    calc() {
      const [chest, back] = [...this.dialog.querySelectorAll('input[type="number"]')].map((i) => parseFloat(i.value));
      const out = this.dialog.querySelector('[data-mz-res]'), apply = this.dialog.querySelector('[data-mz-apply]');
      this.found = {};
      if (!(chest > 0 && back > 0)) { out.innerHTML = 'Inserisci le due misure in centimetri.'; apply.hidden = true; return; }
      const targets = [this.target || 'renna1'];
      const sw = this.querySelector('[data-item="sweater"]');
      if (targets[0] === 'renna1' && sw && !sw.hidden) targets.push('sweater');
      const rows = targets.map((t) => {
        const item = this.querySelector(`[data-item="${t}"]`);
        const s = this.fit(this.data.sizes[item.dataset.product], chest, back);
        if (s === null) return `<p>${item.dataset.label}: tabella taglie in arrivo.</p>`;
        if (s === false) return `<p>${item.dataset.label}: le misure superano la nostra taglia più grande. Scrivici prima di ordinare.</p>`;
        this.found[t] = s.label;
        return `<p>${item.dataset.label}<strong>${s.label}</strong></p>`;
      });
      out.innerHTML = rows.join('');
      apply.hidden = !Object.keys(this.found).length;
    }
    apply() {
      for (const [t, label] of Object.entries(this.found || {})) {
        const r = this.querySelector(`[data-item="${t}"] select[data-opt="2"]`);
        if (r && [...r.options].some((o) => o.value === label)) { r.value = label; r.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      this.dialog.close();
    }
    // --- sticky bar: shown once the add button has scrolled above the viewport ---
    sticky() {
      const bar = document.querySelector('.mz-sticky');
      if (!bar || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(this.btn);
    }
  });

  // --- gift: one bavaglino line (property _regalo) while the cart holds 2+ garments; removed below 2 ---
  const gift = window.mzGift;
  const root = () => window.Shopify?.routes?.root || '/';
  let syncing = false;
  const post = (url, body) => fetch(root() + url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...body, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
  }).then((r) => r.json());
  // Re-renders the drawer without opening it (it is already open when the cart changes from the page).
  const renderCart = (res) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !res.sections) { if (/\/cart\/?$/.test(location.pathname)) location.reload(); return; }
    drawer.getSectionsToRender().forEach((sec) => {
      const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
      if (el && res.sections[sec.id]) el.innerHTML = drawer.getSectionInnerHTML(res.sections[sec.id], sec.selector);
    });
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
  };
  async function syncGift() {
    if (!gift || !gift.variant || syncing) return;
    syncing = true;
    try {
      const cart = await fetch(root() + 'cart.js').then((r) => r.json());
      const n = cart.items.filter((i) => gift.garments.includes(i.handle)).reduce((a, i) => a + i.quantity, 0);
      const line = cart.items.find((i) => i.variant_id === gift.variant && i.properties && i.properties._regalo);
      let res;
      if (n >= 2 && !line) res = await post('cart/add.js', { items: [{ id: gift.variant, quantity: 1, properties: { _regalo: '1' } }] });
      else if (line && (n < 2 || line.quantity !== 1)) res = await post('cart/change.js', { id: line.key, quantity: n < 2 ? 0 : 1 });
      if (!res || res.status) return;
      renderCart(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mz-gift' });
    } catch (e) { /* the discount still works; the line is just not added */ } finally { syncing = false; }
  }
  // --- cart drawer: gilet offer with one tutina (block rendered by cart-drawer.liquid) ---
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mz-up-add]');
    if (!btn) return;
    const box = btn.closest('[data-mz-upsell]');
    const o1 = box.querySelector('[data-mz-up-color]').value, o2 = box.querySelector('[data-mz-up-size]').value;
    const v = JSON.parse(box.querySelector('[data-mz-up-json]').textContent).find((x) => x.o1 === o1 && x.o2 === o2);
    const note = box.querySelector('.mz-upsell__note');
    if (!v || !v.ok) { note.textContent = "Questa combinazione non è disponibile: prova l'altro colore."; return; }
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    try {
      const res = await post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] });
      if (res.status) { note.textContent = res.description || 'Qualcosa non ha funzionato. Riprova.'; return; }
      renderCart(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mz-upsell' });
      else syncGift();
    } catch (err) { note.textContent = 'Connessione assente. Riprova.'; } finally { btn.removeAttribute('aria-busy'); btn.disabled = false; }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => { if (e.source !== 'mz-gift') syncGift(); });
    if (gift && gift.count > 0) syncGift();
  });
})();
